/**
 * Query configuration constants for TanStack Query
 * All polling intervals and query settings in one place
 */

// Time constants (in milliseconds)
export const TIME = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
} as const

// Polling intervals
export const POLLING_INTERVALS = {
  // Backend API - faster updates for user-critical data
  BACKEND_API: 15 * TIME.SECOND, // 15 seconds

  // External APIs - less frequent updates
  EXTERNAL_API: 1 * TIME.MINUTE, // 1 minute (60 seconds)

  // Health check - periodic status verification
  HEALTH_CHECK: 30 * TIME.SECOND, // 30 seconds

  // Feature flags - environment-level configuration
  FEATURE_FLAGS: 30 * TIME.SECOND, // 30 seconds
} as const

// Query stale time (how long data is considered fresh)
export const STALE_TIME = {
  SHORT: 1 * TIME.SECOND, // 1 second
  MEDIUM: 2 * TIME.SECOND, // 2 seconds
  LONG: 30 * TIME.SECOND, // 30 seconds
} as const

// Retry configuration
export const RETRY_CONFIG = {
  ATTEMPTS: 3, // Number of retry attempts
  ATTEMPTS_EXTERNAL: 2, // For external APIs (less retries)
  MAX_DELAY: 30 * TIME.SECOND, // Maximum retry delay
} as const

// Default query options
export const DEFAULT_QUERY_OPTIONS = {
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  retry: RETRY_CONFIG.ATTEMPTS,
  retryDelay: (attemptIndex: number) =>
    Math.min(TIME.SECOND * 2 ** attemptIndex, RETRY_CONFIG.MAX_DELAY),
  staleTime: STALE_TIME.MEDIUM,
} as const
